<!--
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-12-13 16:13:59
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-12-13 16:52:29
 * @FilePath: \distribution_webf:\JOB\blink-zehao-h5\src\views\placeOrder\modules\letterOfAgreementPopup.vue
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <van-popup v-model="visible" position="bottom">
    <div class="agreement-wrapper">
      <p class="title">单独同意书</p>
      <p>本人向贵司或贵司关联公司申请提供精选靓号、话费、流量、宽带、影视会员VIP折扣等通信产品服务，鉴于贵司在业务审查、审批或者其他业务过程需要收集及使用本人信息，本人已充分知悉并明确同意：</p>
      <p>1、鉴于贵司为本人提供前述服务，本人同意，本人所选购通信产品对应的合作运营商（以下称为"个人信息处理者"）有权收集本人下单时提交的个人信息并自行或根据《个人信息保护政策》告知的目的、方式委托贵司处理该等个人信息，且本人确认贵司已向本人充分告知、本人也明确知悉个人信息处理者及信息处理的情况如下：</p>
      <p>（1）涉及的个人信息类型及目的一</p>
      <p>类型：姓名、电话号码、身份证信息</p>
      <p>（2）涉及的个人信息类型及目的二</p>
      <p>类型：收件地址、收件人姓名和电话号码</p>
      <p>目的：运营商提供产品和/服务寄送</p>
      <p>（3）涉及的个人信息类型及目的三</p>
      <p>类型：收件地址、收件人姓名和电话号码</p>
      <p>目的：运营商自行或委托贵司跟进订单服务</p>
      <p>（4）涉及的个人信息类型及目的四</p>
      <p>类型：姓名、电话号码、身份证信息、收件地址</p>
      <p>目的：在本人订购的业务因服务器故障、运营商审核未通过、物流派送第三方问题、自身原因未能成功办理或未激活的情况下向本人推荐符合用户办理条件的其他运营商产品发货，向本人提供同类服务，本人根据实际情况进行拒收或办理，如不同意可在下文勾选对应选项或联系客服【10010 】进行处理。</p>
      <p>（5）本人同意接收贵司或合作商的商业资讯、广告推广信息，如本人认为产品合适，则按照本人意愿自行选择。</p>
      <p>2、本人知悉接收以上个人信息的运营商以本人提交产品和/或服务需求页面展示的运营商为准。</p>
      <p>各运营商的名称、联系方式和对本人个人信息的处理方式如下：</p>
      <p>(1)</p>
      <p>名称：中国移动通信集团有限公司及其子公司、分公司</p>
      <p>联系方式：10086</p>
      <p>处理方式：https://10010.fangzhouad.com/protocol/yidong.html</p>

      <p>(2)</p>
      <p>名称:中国联合网络通信股份有限公司及其子公司、分公司</p>
      <p>联系方式：10010</p>
      <p>处理方式:https://10010.fangzhouad.com/protocol/liantong.html</p>
      <p>(3)</p>
      <p>名称：中国电信股份有限公司及其子公司、分公司</p>
      <p>联系方式：10000</p>
      <p>处理方式:https://10010.fangzhouad.com/protocol/dianxin.html</p>
      <p>(4)</p>
      <p>如运营商上述内容发生变更的，根据运营商官方公布的信息为准。</p>
      <p>勾选视为本人对本条综合商业资讯、广告推广信息内容有异议，勾选后本人将无法享受贵司及合作方提供的相应产品及服务，但不影响享受基础业务。</p>
      <p>勾选视为当本人订购的业务因服务器故障、运营商审核未通过、物流派送第三方问题、自身原因未能成功办理或未激活时，不同意贵司推荐符合办理条件的其他运营商产品发货。</p>
      <p>本人在此声明：</p>
      <p>本人已充分理解上述条款的含义，充分了解该等信息处理活动依赖互联网开展而互联网环境并非绝对安全，本人仍作出上述同意。贵司已经对相关事宜与风险向本人进行充分披露及说明，本人已知晓并同意。本人承诺并保证，本人在本同意书项下所提供的所有本人信息真实、准确、完整、有效，且不会侵犯任何第三方的合法权利。</p>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.agreement-wrapper {
  height: 300px;
  overflow: scroll;
  background-color: #fff;
  text-indent: 28px;
  line-height: 25px;
  padding: 10px 10px;
  p {
    font-size: 12px;
  }
  .title {
    text-indent: 0;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
}
</style>
